import { createSelector } from 'reselect';
import { activeProjectIdSelector } from '@modules/planning/selectors';

export const catalogFilterByProjectSelector = createSelector(activeProjectIdSelector, (defaultChecked) => {
  return { defaultChecked };
});
